import React, { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function DashboardHome() {
  const { profileData, profileLoading, user } = useContext(AuthContext);
  
  // Get country flag emoji based on country name
  const getCountryFlag = (countryName) => {
    const countryFlags = {
      "United Kingdom": "🇬🇧",
      "United States": "🇺🇸",
      "Nigeria": "🇳🇬",
      "Canada": "🇨🇦",
      "France": "🇫🇷",
      "Germany": "🇩🇪",
      "Australia": "🇦🇺",
      "China": "🇨🇳",
      "Japan": "🇯🇵",
      "Spain": "🇪🇸",
      "Ghana": "🇬🇭",
      "South Africa": "🇿🇦",
      "Kenya": "🇰🇪",
    };
    return countryFlags[countryName] || "🌍";
  };

  // Get first two initials for avatar
  const userInitials = user?.email
    ? user.email.slice(0, 2).toUpperCase()
    : "US";

  return (
    <div className="vatug-grid-container">
      {/* Company Profile Card */}
      <div className="vatug-profile-card">
        <div className="vatug-profile-banner"></div>
        <div className="vatug-profile-content">
          <div className="vatug-profile-avatar-container">
            <div className="vatug-profile-avatar">{userInitials}</div>
            <div className="vatug-profile-header-info">
              <h2 className="vatug-profile-name">
                {profileLoading ? (
                  <Skeleton width={150} />
                ) : (
                  profileData?.companyName || "Company Name"
                )}
              </h2>
              <div className="vatug-profile-location">
                <span className="vatug-profile-location-flag">
                  {getCountryFlag(profileData?.country)}
                </span>
                {profileLoading ? (
                  <Skeleton width={200} />
                ) : (
                  <>
                    {profileData?.country || "Country"} | {profileData?.phoneNumber || "Phone Number"}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="vatug-profile-stats">
            <div className="vatug-profile-stat">
              <p className="vatug-profile-stat-label">Total Charters</p>
              <p className="vatug-profile-stat-value blue">8</p>
            </div>
            <div className="vatug-profile-stat">
              <p className="vatug-profile-stat-label">Active Charters</p>
              <p className="vatug-profile-stat-value green">3</p>
            </div>
            <div className="vatug-profile-stat">
              <p className="vatug-profile-stat-label">Pending Requests</p>
              <p className="vatug-profile-stat-value amber">2</p>
            </div>
            <div className="vatug-profile-stat">
              <p className="vatug-profile-stat-label">Completed Charters</p>
              <p className="vatug-profile-stat-value">3</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Contact Person & Upcoming Haggling */}
      <div className="vatug-right-side-container">
        {/* Contact Person */}
        <div className="vatug-card">
          <div className="vatug-card-header">
            <h3 className="vatug-card-title">Contact Person</h3>
          </div>
          <div className="vatug-contact-grid">
            <div>
              <p className="vatug-contact-item-label">Full name</p>
              <p className="vatug-contact-item-value">
                {profileLoading ? (
                  <Skeleton width={120} />
                ) : (
                  "John Smith" || "Not provided"
                )}
              </p>
            </div>
            <div>
              <p className="vatug-contact-item-label">Email</p>
              <p className="vatug-contact-item-value">
                {profileLoading ? (
                  <Skeleton width={180} />
                ) : (
                  "john.smith@company.com" || "Not provided"
                )}
              </p>
            </div>
            <div>
              <p className="vatug-contact-item-label">Phone</p>
              <p className="vatug-contact-item-value">
                {profileLoading ? (
                  <Skeleton width={150} />
                ) : (
                  "+1 234 567 8900" || "Not provided"
                )}
              </p>
            </div>
          </div>
        </div>
        {/* Upcoming Haggling */}
        <div className="vatug-card">
          <h3 className="vatug-card-title">Upcoming Haggling</h3>
          <div className="vatug-haggling-container">
            <div>
              <p className="vatug-contact-item-label">Date</p>
              <p className="vatug-contact-item-value">21 Nov 2024</p>
            </div>
            <div>
              <p className="vatug-contact-item-label">Time</p>
              <p className="vatug-contact-item-value">1:00Pm</p>
            </div>
          </div>
        </div>
      </div>

      {/* Charter Stats Grid */}
      <div className="vatug-vessel-stats-grid">
        <div className="vatug-vessel-stat-card">
          <h3 className="vatug-vessel-stat-label">Vessels Chartered</h3>
          <p className="vatug-vessel-stat-value">8</p>
        </div>
        <div className="vatug-vessel-stat-card">
          <h3 className="vatug-vessel-stat-label">Active Charters</h3>
          <p className="vatug-vessel-stat-value">3</p>
        </div>
        <div className="vatug-vessel-stat-card">
          <h3 className="vatug-vessel-stat-label">Saved Vessels</h3>
          <p className="vatug-vessel-stat-value">5</p>
        </div>
        <div className="vatug-vessel-stat-card">
          <h3 className="vatug-vessel-stat-label">Pending Haggling</h3>
          <p className="vatug-vessel-stat-value">2</p>
        </div>
      </div>
      
      {/* My Charters */}
      <div className="vatug-charter-card">
        <div className="vatug-charter-header">
          <h3 className="vatug-charter-title">My Charters</h3>
          <button className="vatug-see-all-button">See All</button>
        </div>
        <div className="vatug-table-responsive">
          <div className="vatug-table-container">
            <table className="vatug-charter-table">
              <thead>
                <tr>
                  <th>Vessel</th>
                  <th>Vessel Type</th>
                  <th>Shipping Points</th>
                  <th>Duration</th>
                  <th>Pricing</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="vatug-vessel-cell">
                      <div className="vatug-vessel-image">
                        <img
                          src="https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png"
                          alt="Vessel"
                          className="vatug-object-cover"
                        />
                      </div>
                      <span className="vatug-vessel-name">ASD Tug Navigator</span>
                    </div>
                  </td>
                  <td className="vatug-table-cell">AHTS 001</td>
                  <td className="vatug-table-cell">Tincan port - Apapa port</td>
                  <td className="vatug-table-cell">20 Days</td>
                  <td className="vatug-table-cell">$10,000/day</td>
                  <td>
                    <span className="vatug-status-badge active">Active</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="vatug-vessel-cell">
                      <div className="vatug-vessel-image">
                        <img
                          src="https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png"
                          alt="Vessel"
                          className="vatug-object-cover"
                        />
                      </div>
                      <span className="vatug-vessel-name">MPV Atlantic Star</span>
                    </div>
                  </td>
                  <td className="vatug-table-cell">MPV 002</td>
                  <td className="vatug-table-cell">Lagos - Port Harcourt</td>
                  <td className="vatug-table-cell">15 Days</td>
                  <td className="vatug-table-cell">$12,000/day</td>
                  <td>
                    <span className="vatug-status-badge pending">Pending</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="vatug-vessel-cell">
                      <div className="vatug-vessel-image">
                        <img
                          src="https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png"
                          alt="Vessel"
                          className="vatug-object-cover"
                        />
                      </div>
                      <span className="vatug-vessel-name">Platform Supply Vessel</span>
                    </div>
                  </td>
                  <td className="vatug-table-cell">PSV 003</td>
                  <td className="vatug-table-cell">Calabar - Bonny</td>
                  <td className="vatug-table-cell">30 Days</td>
                  <td className="vatug-table-cell">$15,000/day</td>
                  <td>
                    <span className="vatug-status-badge completed">Completed</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
} 